import { z } from 'zod';

/**
 * A whole number typed into one of the catalog admin drawers.
 *
 * Those drawers keep every field as the raw input string — `TextField`
 * registers uncontrolled inputs, `type="number"` included — but the wire
 * schemas type their integer fields as numbers. Resolving a form directly
 * against the request schema therefore rejected every save with "Expected
 * number, received string", including a save that only touched an unrelated
 * field, since one invalid field blocks the whole form. Each drawer overrides
 * the offending field with this and converts to a number on submit.
 *
 * Blank is allowed and means "not recorded": every field using this is either
 * nullable on the wire or defaults to 0.
 */
export function integerStringField(max: number, unit: string) {
  return z
    .string()
    .trim()
    .regex(/^\d*$/, `Expected a whole number of ${unit}`)
    .refine((value) => value === '' || Number(value) <= max, {
      message: `At most ${max} ${unit}`,
    });
}
